import React, { useEffect, useState } from 'react'
import Utils from './utils.js'
import Fetch from './fetch.js'
import { __experimentalInputControl as InputControl } from '@wordpress/components'
import { Button } from '@wordpress/components'

function MailFrom() {

    const [mail_from, setMailFrom] = useState([])
    useEffect(() => {
        async function loadMailFrom() {
            const response = await fetch(DBD.api_mail_from.url, {
                credentials: 'include',
                headers: {
                  'content-type': 'application/json',
                  'X-WP-Nonce': DBD.api_mail_from.nonce
                }
            })
            if(!response.ok) {
                return;
            }
    
            const mailOpt = await response.json();
            if(!mailOpt){
                return;
            }
            
            setMailFrom(mailOpt)
        
        }
    
        loadMailFrom();
        
    }, [])

    if(!mail_from){
        return;
    }

    const saveMailFrom = ( event ) => {
        
        const inputs = JSON.stringify(mail_from)
        let params = {
			url : DBD.api_mail_from.url,
			nonce : DBD.api_mail_from.nonce,
			action : 'save_mail_from',
			data : inputs,
		};
			
        let noticeContainer = document.querySelector('.davenport-theme-options-notice');
		Fetch.send(params,function(message){
            Utils.setNotice(noticeContainer,message);
            localStorage.setItem('active-tab','mail_from');
            location.reload();
        });
    }

    const [mail_fromField, handleChange] = useState({})
    
    mail_from.map((field, index) => {
        //update with child control states
        if(mail_fromField.idx == index){
            field.value = mail_fromField.value
        }
        
    })

    return(
    
        <>
            {mail_from && mail_from.map((field, index) => (
                <InputControl
                    key={index}
                    label={Utils.ucwords(field.name,"_")}
                    name={field.name}
                    type="text"
                    value={ 
                        ( (mail_fromField.idx==index && mail_fromField.value != '') ? mail_fromField.value : field.value)
                    }
                    onChange={ ( newValue ) => {
                    handleChange( {idx:index,value:newValue} )
                    }}
                />
            ))}
            <Button 
                className="btn btn-primary sm save-mail_from" 
                onClick={(e) => {saveMailFrom(e)}}
            >
                Save
            </Button>
        </>
    );

}

export default MailFrom